/* global ajax */
$(document).ready(function() {
  $('body').on('click', '.card--events', function() {
    let $event_id = $(this).data('event-id');
    getEvent($event_id);
  });

  function getEvent(eventID) {
    var data = {
      action: 'get_event',
      nonce: ajax.nonce,
      event_id: eventID,
    };

    $.ajax({
      url: ajax.url,
      type: 'POST',
      data: data,
      success: function(resp) {
        $.fancybox.open(resp);
      },
      error: function(err) {
        console.log(err);
      },
    });
  }
});
